export default "/packs/images/300x400~57489c5ca883e9756ae15503f345f7f8.jpg";